<template>
  <div class="container-fluid">
    <header class="pb-5">
      <PageHeader
        :page="page"
        :has-return="false"
        :left-side-class="'col-xl-8'"
        :right-side-class="
          'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
        "
      >
        <template v-slot:customActions>
          <ActionButton
            v-if="!isFromEvaluationDiscuss"
            text="Regresar"
            i="fas fa-arrow-circle-left fa-fw"
            variant="outline-success"
            class="m-1"
            @click="goBack()"
          />
          <ActionButton
            text="Salir"
            i="fas fa-sign-out fa-fw"
            variant="success"
            class="m-1"
            @click="goToStudentModule"
          />
        </template>
      </PageHeader>
      <Board v-if="studentDetails" :details="studentDetails" />
    </header>
    <section-title
      content="Como resultado del proceso de discusión de las evaluaciones recomendadas a reevaluación se presentan las evaluaciones para el proceso de coordinar citas:"
      :has-line="true"
    />
    <section>
      <row
        v-for="evaluation in studentEvaluations"
        :key="evaluation.id"
        :evaluation="evaluation"
        :student="selectedStudent"
      />
    </section>
  </div>
</template>

<script>
import Board from 'Board';
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import SectionTitle from 'SectionTitle';
import Row from './RowResult';
import studentEvaluationService from '@/modules/student-evaluation-request-managment/api.js';
import studentApi from '@/services/student.js';
import moment from 'moment';

export default {
  name: 'EvaluationAppointment',
  components: {
    PageHeader,
    Board,
    ActionButton,
    SectionTitle,
    Row,
  },
  data() {
    return { studentEvaluations: [], student: {} };
  },
  async mounted() {
    if (this.$route.params.studentSieId) {
      const { data } = await studentApi.getBySie(
        this.$route.params.studentSieId
      );
      this.student = data;
    }

    if (!this.selectedStudent.fullName) this.goToStudentModule();
    this.getEvaluations();
  },
  computed: {
    isFromEvaluationDiscuss() {
      return this.$route.params.from == 'evaluationDiscuss';
    },
    selectedStudent() {
      if (this.$route.params.studentSieId) {
        return {
          fullName: this.student.fullName,
          studentId: parseInt(this.student.studentId ?? 0),
          impediment: this.student.impediment,
          schoolName: `${this.student.schoolCode} - ${this.student.schoolName}`,
          age: parseInt(
            moment().diff(this.student.dateOfBirth, 'years', false) ?? 0
          ),
        };
      } else {
        const selectedStudent =
          this.$store.getters['$_student/SelectedStudent'] ?? {};
        const { mipeStudent, age } =
          this.$store.getters['$_student/getMipeStudent'] ?? {};

        return {
          fullName: selectedStudent.fullName,
          studentId: parseInt(selectedStudent.studentId ?? 0),
          impediment: selectedStudent.impediment,
          schoolName: mipeStudent.school,
          age: parseInt(age ?? 0),
        };
      }
    },
    isUserPilotPlan() {
      return this.$store.getters['$_user/pilotPlan'];
    },
    page() {
      return {
        icon: 'fas fa-user-edit',
        title: 'Proceso de Discusión de Evaluación en COMPU',
        routes: [
          'Inicio',
          'Estudiante',
          'Proceso de Discusión de Evaluación en COMPU',
        ],
      };
    },
    studentDetails() {
      if (!this.selectedStudent) return;
      return [
        [
          {
            label: 'Estudiante',
            data: this.selectedStudent.fullName,
            icon: 'fas fa-address-book',
          },
          {
            label: 'Número SIE',
            data: this.selectedStudent.studentId,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Escuela',
            data: this.selectedStudent.schoolName,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Impedimento',
            data: this.selectedStudent.impediment,
            icon: 'fas fa-clipboard-list-check',
          },
        ],
      ];
    },
  },
  methods: {
    goToStudentModule() {
      this.$router.push({ path: '/student' });
    },
    goBack() {
      if (!this.$route.params.isFromTrianual) {
        this.$router.go(-1);
      }

      this.$router.replace({
        path: `/student/ProcessDeterminationTriannualView/${this.$route.params.evaluationDateId}`,
        query: {
          isSubmitted: true,
          isFromDetermination: this.$route.params.isFromDetermination,
          isFromDetailCoordination: false,
        },
      });
    },
    async getEvaluations() {
      const {
        data: response,
      } = await studentEvaluationService.getAvailableEvaluations(
        this.selectedStudent.studentId
      );
      this.studentEvaluations = response.data;
    },
  },
};
</script>

<style></style>
